import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://vcefjgbqdhcpaohorjjv.supabase.co"

const supabaseKey = "sb_publishable_0okq3bGrMzp2bOfImcIvGw_9j3kSpbk"

export const supabase = createClient(supabaseUrl, supabaseKey, {
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  fetch: (url, options) => {
    return fetch(url, {
      ...options,
      headers: {
        ...options?.headers,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
  }
})